module.exports = __webpack_public_path__ + "static/media/shadowhall.43886c76.webp";